import ClearIcon from "../ClearIcon/ClearIcon";
import "./styles/Chip.scss";

interface IProps {
    displayText: string;
    id: string;
    onDelete: (id: string) => void;
}

const Chip = ({ displayText, id, onDelete }: IProps) => {
    return (
        <div className="chip">
            <p>{displayText}</p>
            <button
                type="button"
                className="chip__clear"
                onClick={() => onDelete(id)}
                aria-label={`Remove ${displayText} from selection`}
            >
                <ClearIcon />
            </button>
        </div>
    );
};
export default Chip;
